import { Route, Routes } from 'react-router-dom'
import RootLayout from 'app/layout'
import HomePage from 'app/page'
import AuthLayout from 'app/(auth)/layout'
import LoginPage from 'app/(auth)/login/page'
import RegisterPage from 'app/(auth)/register/page'
import ResetPasswordPage from 'app/(auth)/reset-password/page'
import DashboardLayout from 'app/dashboard/layout'
import DashboardPage from 'app/dashboard/page'
import AwardsPage from 'app/dashboard/awards/page'
import AwardDetailPage from 'app/dashboard/awards/detail/page'
import ProposalsPage from 'app/dashboard/proposals/page'
import NewProposalPage from 'app/dashboard/proposals/new/page'
import ProposalDetailPage from 'app/dashboard/proposals/detail/page'
import ProjectsPage from 'app/dashboard/projects/page'
import NewProjectPage from 'app/dashboard/projects/new/page'
import ProjectLayout from 'app/dashboard/projects/detail/layout'
import ProjectOverviewPage from 'app/dashboard/projects/detail/overview'
import ProjectTeamPage from 'app/dashboard/projects/detail/team'
import ProjectWorkplanPage from 'app/dashboard/projects/detail/workplan'
import ProjectBudgetPage from 'app/dashboard/projects/detail/budget'
import ProjectTrackingPage from 'app/dashboard/projects/detail/tracking'
import ProjectMonitoringPage from 'app/dashboard/projects/detail/monitoring'
import ProjectPartnersPage from 'app/dashboard/projects/detail/partners'
import ProjectDocumentsPage from 'app/dashboard/projects/detail/documents'
import ProjectRisksPage from 'app/dashboard/projects/detail/risks'
import ProjectAuditPage from 'app/dashboard/projects/detail/audit'
import ProjectIssuesPage from 'app/dashboard/projects/detail/issues'
import WorkplansPage from 'app/dashboard/workplans/page'
import MelPage from 'app/dashboard/mel/page'
import MelIndicatorsPage from 'app/dashboard/mel/indicators/page'
import EvidencePage from 'app/dashboard/evidence/page'
import ReportsPage from 'app/dashboard/reports/page'
import ReportsCompliancePage from 'app/dashboard/reports/compliance/page'
import RisksPage from 'app/dashboard/risks/page'
import IssuesPage from 'app/dashboard/issues/page'
import StakeholdersPage from 'app/dashboard/stakeholders/page'
import PartnersPage from 'app/dashboard/partners/page'
import FinancePage from 'app/dashboard/finance/page'
import DeliveryDashboardPage from 'app/dashboard/dashboards/delivery/page'
import MelDashboardPage from 'app/dashboard/dashboards/mel/page'
import RisksDashboardPage from 'app/dashboard/dashboards/risks/page'
import OutputsDashboardPage from 'app/dashboard/dashboards/outputs/page'
import AdminUsersPage from 'app/dashboard/admin/users/page'
import AdminAuditPage from 'app/dashboard/admin/audit/page'
import ProfilePage from 'app/dashboard/profile/page'
import SettingsPage from 'app/dashboard/settings/page'

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background p-6 text-center">
      <h1 className="text-3xl font-bold text-foreground">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you are looking for doesn&apos;t exist or has moved.
      </p>
    </div>
  )
}

export default function App() {
  return (
    <RootLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Route>

        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="proposals" element={<ProposalsPage />} />
          <Route path="proposals/new" element={<NewProposalPage />} />
          <Route path="proposals/:id" element={<ProposalDetailPage />} />
          <Route path="awards" element={<AwardsPage />} />
          <Route path="awards/:id" element={<AwardDetailPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projects/new" element={<NewProjectPage />} />
          <Route path="projects/:id" element={<ProjectLayout />}>
            <Route index element={<ProjectOverviewPage />} />
            <Route path="overview" element={<ProjectOverviewPage />} />
            <Route path="team" element={<ProjectTeamPage />} />
            <Route path="workplan" element={<ProjectWorkplanPage />} />
            <Route path="budget" element={<ProjectBudgetPage />} />
            <Route path="tracking" element={<ProjectTrackingPage />} />
            <Route path="monitoring" element={<ProjectMonitoringPage />} />
            <Route path="partners" element={<ProjectPartnersPage />} />
            <Route path="documents" element={<ProjectDocumentsPage />} />
            <Route path="risks" element={<ProjectRisksPage />} />
            <Route path="audit" element={<ProjectAuditPage />} />
            <Route path="issues" element={<ProjectIssuesPage />} />
          </Route>
          <Route path="workplans" element={<WorkplansPage />} />
          <Route path="mel" element={<MelPage />} />
          <Route path="mel/indicators" element={<MelIndicatorsPage />} />
          <Route path="evidence" element={<EvidencePage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="reports/compliance" element={<ReportsCompliancePage />} />
          <Route path="risks" element={<RisksPage />} />
          <Route path="issues" element={<IssuesPage />} />
          <Route path="stakeholders" element={<StakeholdersPage />} />
          <Route path="partners" element={<PartnersPage />} />
          <Route path="finance" element={<FinancePage />} />
          <Route path="dashboards/delivery" element={<DeliveryDashboardPage />} />
          <Route path="dashboards/mel" element={<MelDashboardPage />} />
          <Route path="dashboards/risks" element={<RisksDashboardPage />} />
          <Route path="dashboards/outputs" element={<OutputsDashboardPage />} />
          <Route path="admin/users" element={<AdminUsersPage />} />
          <Route path="admin/audit" element={<AdminAuditPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </RootLayout>
  )
}
